"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_tracker_1 = require("@snowplow/browser-tracker");
/**
 * Sends the self-describing event and any provided contexts
 */
const enhancedSelfDescribingEvent = (event) => {
    (0, browser_tracker_1.trackSelfDescribingEvent)(event);
};
exports.default = enhancedSelfDescribingEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZW5oYW5jZWRTZWxmRGVzY3JpYmluZ0V2ZW50L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsK0RBQXFFO0FBR3JFOztHQUVHO0FBQ0gsTUFBTSwyQkFBMkIsR0FBRyxDQUNoQyxLQUEyRSxFQUN2RSxFQUFFO0lBQ04sSUFBQSwwQ0FBd0IsRUFBQyxLQUFLLENBQUMsQ0FBQztBQUNwQyxDQUFDLENBQUM7QUFFRixrQkFBZSwyQkFBMkIsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/utils/enhancedSelfDescribingEvent/index.ts